import { createTopic } from '../lib';
import { z } from 'zod';

const descriptorDownloadedEventSchema = z.object({
  entityUrn: z.string(),
  kind: z.string(),
  environment: z.string().optional(),
  parentSystem: z
    .object({ urn: z.string(), environment: z.string() })
    .optional(),
});

export type DescriptorDownloadedEvent = z.infer<
  typeof descriptorDownloadedEventSchema
>;

export const descriptorDownloadedTopic = createTopic<DescriptorDownloadedEvent>(
  {
    namespace: 'marketplace',
    name: 'descriptor-downloaded',
    description: 'User downloaded the descriptor of an entity.',
  },
  descriptorDownloadedEventSchema,
);
